import { Routes, Route, Link, useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { BookshelfProvider } from "./contexts/BookshelfContext";
import { NightModeProvider } from "./contexts/NightModeContext";
import HomePage from "./pages/HomePage";
import AgeGroupPage from "./pages/AgeGroupPage";
import StoryPage from "./pages/StoryPage";
import CategoryPage from "./pages/CategoryPage";
import BookshelfPage from "./pages/BookshelfPage";

function NavBar() {
  const location = useLocation();

  // Hide nav on story reader pages for immersive experience
  const isStoryPage = /^\/age\/[^/]+\/[^/]+/.test(location.pathname);
  if (isStoryPage) return null;

  return (
    <nav className="bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700 sticky top-0 z-50">
      <div className="max-w-6xl mx-auto px-6 py-3 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <span className="text-xl font-bold bg-gradient-to-r from-purple-600 to-pink-500 bg-clip-text text-transparent" style={{ fontFamily: "'Fredoka', sans-serif" }}>
            Wisdom Whispers
          </span>
        </Link>

        <div className="flex items-center gap-4">
          <Link
            to="/bookshelf"
            className="text-sm text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors"
          >
            Bookshelf
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BookshelfProvider>
        <NightModeProvider>
          <NavBar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/age/:ageGroup" element={<AgeGroupPage />} />
            <Route path="/age/:ageGroup/:slug" element={<StoryPage />} />
            <Route path="/category/:category" element={<CategoryPage />} />
            <Route path="/bookshelf" element={<BookshelfPage />} />
            {/* Catch-all */}
            <Route path="*" element={
              <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-6">
                <h1 className="text-4xl font-bold mb-4">Page Not Found</h1>
                <p className="text-gray-500 mb-8">The story you're looking for doesn't exist yet.</p>
                <Link to="/" className="px-6 py-3 rounded-lg bg-purple-600 text-white hover:bg-purple-700 transition-colors">
                  Go Home
                </Link>
              </div>
            } />
          </Routes>
        </NightModeProvider>
      </BookshelfProvider>
    </AuthProvider>
  );
}
